import moment from 'moment'

class User {
    username = ''
    token = ''
    vipEndTime = moment()
    vipLeftSeconds = 0
    hasMembership = false
    notice = ''
    recoverCode = ''

    getVipEndTimeStr = () => {
        return this.vipEndTime.format('YYYY年MM月DD日')
    }

    getVipLeftDays = () => {
        return Math.floor(this.vipLeftSeconds / 3600 / 24)
    }

    getVipLeftHours = () => {
        return Math.floor((this.vipLeftSeconds / 3600) % 24)
    }

    getVipLeftMin = () => {
        return Math.floor((this.vipLeftSeconds / 60) % 60)
    }

    serialize(): string {
        return JSON.stringify(this)
    }

    setProperties(props: any) {
        this.username = props.username
        this.token = props.token
        this.vipEndTime = moment(props.vipEndTime)
        this.vipLeftSeconds = Number(props.vipLeftSeconds)
        this.hasMembership = props.hasMembership === 'true' ? true : false
        this.notice = props.notice
        this.recoverCode = props.recoverCode || ''
    }

}

export default User;
